// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const debounce = <F extends (...args: any[]) => unknown>(func: F, wait: number) => {
    let timeout: ReturnType<typeof setTimeout>;

    type RetVal = ReturnType<F>;
    type DebouncedRetVal = RetVal extends Awaited<unknown> ? RetVal : Promise<RetVal>;

    return function (...args: Parameters<F>) {
        return new Promise(resolve => {
            if (timeout) {
                clearTimeout(timeout);
            }

            timeout = setTimeout(() => {
                const result = func(...args);
                if (result instanceof Promise) {
                    result.then(resolve);
                    return;
                }
                resolve(result);
            }, wait);
        }) as DebouncedRetVal;
    };
};
